export function all(state) {
  return state.notifications;
}

export function networkError(state) {
  return state.networkError;
}
